"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
/** Header of a side panel: title · one state · one action; 48 px, full width of the panel, sticky on scroll. */
export function PanelHead({ title, children, end, headingLevel = 3, className }) {
    const Heading = headingLevel === 2 ? "h2" : "h3";
    return _jsxs("div", { className: cx("jui-phead", className), children: [_jsx(Heading, { className: "jui-phead-title", children: title }), children && _jsx("span", { className: "jui-phead-meta", children: children }), end && _jsx("span", { className: "jui-phead-end", children: end })] });
}
